<template>
    <div class="component power-hours-stats-table">
        <el-card class="box-card" v-loading="loading">
            <h4 class="title text-left" slot="header">Statistics</h4>
            <el-table
                :data="getData"
                style="width: 100%"
                :row-class-name="tableRowClassName"
                :cell-style="cellStyling">
                <el-table-column  v-for="col in headers"
                                  :key="col.prop"
                                  :prop="col.prop"
                                  :label="col.prop | formatVariableName"
                                  :sortable=false
                                  :formatter="formatter">
                </el-table-column>

            </el-table>
        </el-card>
    </div>
</template>

<script>
import axios from '@/services/axios.js'
import { getHeadersWithAccessToken, getTableHeaders, formatString } from '../../functions'

export default {
    data () {
        return {
            loaded: false,
            loading: true,
            data: [],
            columns: [],
            windowWidth: 0
        }
    },
    methods: {
        getTableData (store) {
            if (this.$store.state.graphFilter.powerhoursSelectedStore !== null) {
                this.loading = true
                let params = { 'format': 'aod', 'store_id': [this.$store.state.graphFilter.powerhoursSelectedStore] }
                axios.post(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_DATA_API_BASE_URL_DEV : process.env.VUE_APP_DATA_API_BASE_URL) + '/at/performance/powerhours/statistics', params, { headers: getHeadersWithAccessToken() })
                    .then(response => {
                        this.data = response.data.data
                        this.columns = getTableHeaders(response.data.columns)
                        this.loaded = true
                        this.loading = false
                    }).catch(error => {
                        console.log(error)
                    })
            }
        },
        formatter (row, column) {
            if (column.property === 'weekday') {
                return formatString(row[column.property])
            } else if (column.property.includes('share') || column.property.includes('hours_advice') || column.property.includes('hours_actual')) {
                return String((parseFloat(row[column.property]) * 100).toFixed()) + '%'
            } else {
                return row[column.property].toLocaleString('en-EN')
            }
        },
        tableRowClassName ({ row, rowIndex }) {
            if (row.weekday === 'total') {
                return 'highlight-row'
            }
        },
        cellStyling (param) {
            const { column, row } = param
            if (column.property === 'power_hours_score' && row[column.property] !== null) {
                if (row['power_hours_score'] > 8) {
                    return { backgroundColor: 'rgba(39, 149, 151, 0.5)', 'borderBottom': '0px' }
                } else if (row['power_hours_score'] > 6 || row['power_hours_score'] === 0) {
                    return { backgroundColor: '#EBEEF5', 'borderBottom': '0px' }
                } else {
                    return { backgroundColor: 'rgba(245, 108, 108, 0.5)', 'borderBottom': '0px' }
                }
            }
        }
    },
    computed: {
        getData () {
            if (this.loaded === false) {
                return []
            } else {
                return this.data
            }
        },
        headers () {
            if (this.loaded === false) {
                return []
            }
            if (parseInt(this.windowWidth) < 1600 && parseInt(this.windowWidth) > 990) {
                let c = JSON.parse(JSON.stringify(this.columns))
                let item = c.find(x => x.prop === 'hours_actual')
                if (item !== undefined) {
                    let idx = c.indexOf(item)
                    c.splice(idx, 1)
                }
                item = c.find(x => x.prop === 'hours_advice')
                if (item !== undefined) {
                    let idx = c.indexOf(item)
                    c.splice(idx, 1)
                }
                return c
            }

            return this.columns
        }
    },
    mounted () {
        this.windowWidth = window.innerWidth
        window.addEventListener('resize', () => {
            this.windowWidth = window.innerWidth
        })
    }
}
</script>
